/**
 * ErrorAlert - Reusable error alert component
 * Replaces alert() calls with proper Material-UI Alert
 */

import React from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';

export interface ErrorAlertProps {
  message: string;
  title?: string;
  severity?: 'error' | 'warning' | 'info' | 'success';
  onClose?: () => void;
  action?: {
    label: string;
    onClick: () => void;
  };
  fullWidth?: boolean;
  sx?: any;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  message,
  title,
  severity = 'error',
  onClose,
  action,
  fullWidth = true,
  sx
}) => {
  return (
    <Alert
      severity={severity}
      onClose={onClose}
      sx={{
        width: fullWidth ? '100%' : 'auto',
        mb: 2,
        ...sx
      }}
      action={
        action ? (
          <Button color="inherit" size="small" onClick={action.onClick}>
            {action.label}
          </Button>
        ) : undefined
      }
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  );
};

export default ErrorAlert;
